<template>
  <snack-bar class="failed-payment-notification-bar" v-if="subscriptionIsCanceled"
             :variant="'danger'"
             :text="'לא הצלחנו לחייב את הכרטיס'">
    <template v-slot:secondary>
      <div class="cta underline" v-on:click="openUpdateCreditCardPopup">לעדכון אמצעי תשלום</div>
    </template>
  </snack-bar>
</template>

<script>

import { mapState } from 'vuex';

import BaseUI from 'base-ui';
import UpdateCreditCardHandler from '../UpdateCreditCardHandler.vue';
import { SUBSCRIPTION_STATES } from '../../../../../../constants/subscription-state';

export default {
  name: 'FailedPaymentNotificationBar',
  mixins: [UpdateCreditCardHandler],
  components: {
    SnackBar: BaseUI.SnackBar,
  },
  computed: {
    ...mapState('subscriptionState', ['subscriptionState']),
    subscriptionIsCanceled() {
      return this.subscriptionState && this.subscriptionState === SUBSCRIPTION_STATES.CANCELED;
    },
  },
};

</script>

<style scoped lang="scss">
  @import '../../../../../../scss/mixins';

  .failed-payment-notification-bar {
    @include responsive-padding;

    .cta {
      color: $riseup_white;
      cursor: pointer;

      &.underline {
        text-decoration: underline;
      }
    }

  }
</style>
